import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllPatrimonioMaquinaEquipUseCase } from "../../../presentation/useCases/read/get_all_patrimonio_maquina_equip_use_case";
import { PatrimonioMaquinaEquipListaModel } from "../../models/patrimonio_maquina_equip_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
/**
 * GetAllPatrimonioMaquinaEquipUseCase
 */

export class GetAllPatrimonioMaquinaEquipUseCase
  extends BasePaginatedUseCase<PatrimonioMaquinaEquipListaModel>
  implements IGetAllPatrimonioMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllPatrimonioMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    descricao?: string,
    status?: number,
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const response = await this.repository.getAllPatrimonioMaquinaEquip(
      idPatrimonioCentroCusto,
      descricao ?? undefined,
      status ?? undefined,
      page ?? 1,
      rowsPerPage ?? 100,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
